import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { authAxios as axios } from "api-generate-types/src/axios";
import { config } from "../../../../config";

export const FETCH_SUBSCRIPTION_ACTIONS = "FETCH_SUBSCRIPTION_ACTIONS";

export interface SubscriptionActions {
  isEligibleForGradTransfer: boolean;
  isEligibleToCancel: boolean;
  isEligibleToChangePlan: boolean;
  isEligibleToReactivate: boolean;
  isEligibleToReinstate: boolean;
  isEligibleToRenew: boolean;
}

export function useGetSubscriptionActions(enabled: boolean = false) {
  return useQuery<SubscriptionActions, AxiosError>(
    [FETCH_SUBSCRIPTION_ACTIONS],
    async () => {
      const { data } = await axios.get(
        `${config.billingApiUrl}subscription/actions`
      );

      return data;
    },
    {
      enabled,
      cacheTime: 0,
    }
  );
}
